module.exports = __webpack_public_path__ + "img/pix-106.eb23914b.svg";